import * as React from "react";
import { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { Grid, Button } from '@material-ui/core';
import moment from 'moment';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import RequestAccessToken from '../util/authService';
import { Typography } from "@material-ui/core";
import Hidden from '@material-ui/core/Hidden';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import { practiceCoordinatorLoaded, shouldTryCareCoordinatorProfile, shouldTryRefMDProfile } from "./common/ProfileHelper";


type MessagesForProviderProps = {
    Messages : APIStore.MessageState,
    APIToken : APIStore.TokenType,
    userPracticeCoordinatorProfile : APIStore.PracticeCoordinatorState,
    userRefMdProfile : APIStore.RefMDProfileState

} &
    typeof APIStore.actionCreators;

const findMessage = (messageId: number, messages: APIStore.Message[]) => {
    let ret = messages.filter((val) => val.messageId === messageId);
    if (!ret.length) {
        return null;
    }

    return ret[0];
};

const formatDate = (date) => {
    return moment(date).format("hh:mm A MM/DD/YY");
};

const formatSender = (message: APIStore.Message) => {
    // format physician names
    // potentially display phone
    // properly display VitalsMD symbol

    let messageType = message.description;
    if (!messageType) {
        return '';
    }
    if (messageType.toLowerCase() === 'admit' || messageType.toLowerCase() === 'discharge') {
        return 'VitalsMD';
    }

    return message.senderId;
};

const formatSubject = (fullMessage: APIStore.Message) => {


    let messageType = fullMessage.description;


    if (!messageType) {
        return '';
    }
    if (messageType.toLowerCase() === 'admit') {
        return `Patient Admit: ${fullMessage.patientLastName}`
    }

    if (messageType.toLowerCase() === 'discharge') {
        return `Patient Discharge: ${fullMessage.patientLastName}`
    }


    return fullMessage.subject;
};

const NotifcationsTable = (props: MessagesForProviderProps) => {
    let {
        requestMessagesForProvider,
        requestMessageContactsUser,
        userRefMdProfile,
        requestVitalsMdProfile,
        Messages,
        clearMessageState,
        requestMessageContactsForPractice,
        requestCurrentUserCareCoordinatorProfile,
        userPracticeCoordinatorProfile,
        receiveTokenResponse,
        APIToken } = props;
    let { isLoading, isLoaded } = Messages;
    let CurrentMessages: APIStore.Message[] = Messages.CurrentMessages;
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let [careCoordinatorProfileState, setCareCoordinatorProfileState] = useState<APIStore.CareCoordinatorModel>();
    let tableTitle: string = 'Messages';
    let aProfileIsLoaded: boolean = false;

    const columns = [
        {
            name: "Message",
            options: {
                display: false,
            }
        },
        "Subject",
        "Sender",
        "Sent", {
            name: "Status",
            options: {
                display: false,
            }
        }, {
            name: "Yours",
            options: {
                display: false,
            }
        }];

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
                receiveTokenResponse(token);
            }
        });

    useEffect(() => {
        if (APIToken && !tokenState?.accessToken) {
            setTokenState(APIToken);
        }

    }, [APIToken, tokenState])

    useEffect(() => {
        if (userPracticeCoordinatorProfile) {
            let { isLoaded, isLoading, coordinatorProfile }: APIStore.PracticeCoordinatorState = userPracticeCoordinatorProfile;


            if (isLoaded && !isLoading && tokenState?.accessToken) {
                setCareCoordinatorProfileState(coordinatorProfile);
                aProfileIsLoaded = true;
                requestMessageContactsForPractice(tokenState.accessToken, coordinatorProfile.defaultPractice.practiceId);
                requestMessagesForProvider(tokenState.accessToken);
            }
        }

    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile, Messages.isLoaded]);



    useEffect(() => {
        if (userRefMdProfile && tokenState && !practiceCoordinatorLoaded(userPracticeCoordinatorProfile)) {
            let { notFound, isLoaded, isErrored, isLoading }: APIStore.RefMDProfileState = userRefMdProfile;
            if (shouldTryRefMDProfile(userRefMdProfile) && userPracticeCoordinatorProfile.notFound) {
                requestVitalsMdProfile(tokenState.accessToken);
            }

            if (isLoaded) {
                requestMessagesForProvider(tokenState?.accessToken);
                requestMessageContactsUser(tokenState?.accessToken);
                aProfileIsLoaded = true;
            }

            if (shouldTryCareCoordinatorProfile(userPracticeCoordinatorProfile)) {
                requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);
            }
        }
    }, [tokenState, userRefMdProfile, userPracticeCoordinatorProfile]);

    const handleClose = () => {
        clearMessageState();
    }

    const history = useHistory();

    const getMuiTheme = () =>
        createTheme({

        });


    const options = {
        elevation: 0,
        filter: false,
        viewColumns: false,
        print: false,
        download: false,
        customFooter: null,
        selectableRows: false,
        delete: false,
        searchAlwaysOpen: false,
        responsive: 'vertical',
        customRowRender: (data, dataIndex, rowIndex) => {
            let outbound = data[5];
            let readStr = data[4];

            if (!readStr && !outbound) {

                return (<TableRow onClick={() => { GotoNotificationItem(data[0]) }}>

                    <TableCell colSpan={1}>
                        <strong>
                            {
                                data[1]
                            }
                        </strong>
                    </TableCell>
                    <TableCell colSpan={1}>
                        <strong>
                            {
                                data[2]
                            }
                        </strong>
                    </TableCell>
                    <TableCell colSpan={1}>
                        <strong>
                            {
                                data[3]
                            }
                        </strong>
                    </TableCell>
                </TableRow>)
            }


            if (outbound) {
                return (<TableRow onClick={() => { GotoNotificationItem(data[0]) }}>


                    <TableCell colSpan={1}>
                        <i> {
                            data[1]
                        }</i>

                    </TableCell>
                    <TableCell colSpan={1}>
                        You
                    </TableCell>
                    <TableCell colSpan={1}>
                        <i>    {
                            data[3]
                        }</i>

                    </TableCell>
                </TableRow>)
            }

            return (<TableRow onClick={() => { GotoNotificationItem(data[0]) }}>

                <Hidden mdUp>
                    <TableCell>
                        <Grid container direction="row" className="notificationsgrid">
                            <Grid item>
                                <Typography variant="body2" component="div" gutterBottom>
                                    <strong>{
                                        data[2]
                                    }</strong>

                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="smalldate" component="div" gutterBottom>
                                    {
                                        data[3]
                                    }

                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" component="div" gutterBottom>
                                    {
                                        data[1]
                                    }
                                </Typography>
                            </Grid>
                        </Grid>
                    </TableCell>
                </Hidden>

                <Hidden smDown>
                    <TableCell colSpan={1}>
                        {
                            data[1]
                        }
                    </TableCell>
                    <TableCell colSpan={1}>
                        {
                            data[2]
                        }
                    </TableCell>
                    <TableCell colSpan={1}>
                        {
                            data[3]
                        }
                    </TableCell>
                </Hidden>
            </TableRow>)
        }
    };


    const loadingOptions = {
        filter: false,
        viewColumns: false,
        print: false,
        download: false,
        delete: false,
        searchAlwaysOpen: false,
        customRowRender: (data, dataIndex, rowIndex) => {

            if (dataIndex === 0) {
                return (
                    <TableRow className="animate-flicker">
                        <TableCell className='skeleton' colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className='skeleton' colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className='skeleton' colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className='skeleton' colSpan={1}>
                            &#8239;
                        </TableCell>
                        <TableCell className='skeleton' colSpan={1}>
                            &#8239;
                        </TableCell>
                    </TableRow>
                );
            }

            return (
                <TableRow className="animate-flicker">
                    <TableCell className='skeleton-light' colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className='skeleton-light' colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className='skeleton-light' colSpan={1}>

                    </TableCell>
                    <TableCell className='skeleton-light' colSpan={1}>
                        &#8239;
                    </TableCell>
                    <TableCell className='skeleton-light' colSpan={1}>
                        &#8239;
                    </TableCell>
                </TableRow>
            );
        },

        customFooter: (
            count,
            page,
            rowsPerPage,
            changeRowsPerPage,
            changePage
        ) => {
            const startIndex = page * rowsPerPage;
            const endIndex = (page + 1) * rowsPerPage;
            return (
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={1}>
                            Loading
                        </TableCell>
                        <TableCell colSpan={1}>

                        </TableCell>
                        <TableCell colSpan={1}>

                        </TableCell>
                        <TableCell colSpan={1}>

                        </TableCell>
                        <TableCell colSpan={1}>

                        </TableCell>
                        <TableCell colSpan={1}>

                        </TableCell>
                    </TableRow>
                </TableFooter>
            );
        },
        textLabels: {
            body: {
                noMatch: "Loading",
            }
        }
    };

    const GotoNotificationItem = (data: number) => {
        let message = CurrentMessages.filter(v => v.messageId === data)[0];



        if (message.description === 'user') {
            history.push(`/notification-item/${message.messageId}`);
        };

        if (message.description === 'admit') {
            history.push(`/admit-notification/${message.messageId}`);
        };

        if (message.description === 'discharge') {
            history.push(`/discharge-notification/${message.messageId}`);
        };
    }

    const newMessage = () => {
        history.push("/compose-new-message");
    };


    if ((isLoading || !isLoaded)) {
        return (
            <div>
                <Grid container spacing={12} className="noticebar"
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <Grid item>
                        <Typography variant="p">
                            If immediate attention is required contact us at 855-489-8141
                        </Typography>

                    </Grid>
                </Grid>
                <div className="mui-datatable">
                    <ThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            title={"Messages"}
                            data={[['col1', 'col2', 'col3', 'col4', 'col5'], ['col1', 'col2', 'col3', 'col4', 'col5']]}
                            columns={columns}
                            options={loadingOptions}
                        />
                    </ThemeProvider>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Grid container spacing={12} className="noticebar"
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid item>
                    <Typography variant="p">
                        If immediate attention is required contact us at 855-489-8141
                    </Typography>

                </Grid>
            </Grid>
            <div className="mui-datatable">
                <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={CurrentMessages.map((item: APIStore.Message) => {

                            return [item.messageId, formatSubject(item), formatSender(item), formatDate(item.createdDate), item.messageReadDate, item.isOutbound];
                        })}
                        columns={columns}
                        options={options}
                    />
                </ThemeProvider>
            </div>
        </div>


    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(NotifcationsTable as any);

